import React from 'react';
import { Container, Typography, ToggleButtonGroup, ToggleButton, Box, Divider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import OpenOrder from '../Tabels/OpenOrder';
import ExecutedOrder from '../Tabels/ExecutedOrder';

function Order() {
  const location = useLocation();
  const onboardingType = location.state?.onboardingType || 'crypto';
  const [mainType, setMainType] = React.useState<'crypto' | 'stock'>(() =>
    onboardingType === 'crypto' ? 'crypto' : 'stock'
  );
  const [selectedCategory, setSelectedCategory] = React.useState<string>(() =>
    (location.state && (location.state as any).selectedCategory) || 'Open'
  );
  const navigation = useNavigate();

  const handleMainType = (
    event: React.MouseEvent<HTMLElement>,
    newType: 'crypto' | 'stock' | null
  ) => {
    if (newType) {
      setMainType(newType);
      setSelectedCategory(newType === 'crypto' ? 'Initiated' : 'Open');
    }
  };

  const handleSelectedCategory = (
    event: React.MouseEvent<HTMLElement>,
    newCategory: string | null
  ) => {
    if (newCategory !== null) {
      setSelectedCategory(newCategory);
    }
  };

  return (
    <Container maxWidth={false} className="bg-color" style={{ minHeight: 'calc(100vh - 71px - 143px)', display: 'flex', flexDirection: 'column' }}>
      <Box padding='30px' flexGrow='1' >
        <Typography
          className="text-secondary"
          sx={{ marginBottom: "20px" }}
        >
          {" "}
          <span
            onClick={() => navigation(-1)}
            style={{ color: '#4A7AF2', cursor: 'pointer' }}
          >
            More Options
          </span>{' '}
          / Order
        </Typography>
        {/* Main Type Toggle */}
        <ToggleButtonGroup
          value={mainType}
          exclusive
          onChange={handleMainType}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            borderRadius: '20px',
            bgcolor: '#ffffff1a ',
            mb: 2,
          }}
          aria-label="Order Type"
        >
          <ToggleButton
            value="crypto"
            className="text-white"
            sx={{
              flexGrow: 1,
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '20px',
              borderColor: 'transparent !important',
              borderRadius: '20px !important',
              '&:hover': {
                bgcolor: '#f2674a !important',
                color: 'white !important',
                borderColor: '#f2674a !important',
              },
              '&.Mui-selected': {
                bgcolor: '#f2674a !important',
                color: 'white !important',
                borderColor: '#f2674a !important',
              },
            }}
          >
            Crypto
          </ToggleButton>
          <ToggleButton
            value="stock"
            className="text-white"
            sx={{
              flexGrow: 1,
              textTransform: 'none',
              fontWeight: '600',
              fontSize: '20px',
              borderColor: 'transparent !important',
              borderRadius: '20px !important',
              '&:hover': {
                bgcolor: '#f2674a !important',
                color: 'white !important',
                borderColor: '#f2674a !important',
              },
              '&.Mui-selected': {
                bgcolor: '#f2674a !important',
                color: 'white !important',
                borderColor: '#f2674a !important',
              },
            }}
          >
            Stock/ETF
          </ToggleButton>
        </ToggleButtonGroup>
        {/* Category Toggle */}
        <ToggleButtonGroup
          value={selectedCategory}
          exclusive
          onChange={handleSelectedCategory}
          size="small"
          aria-label="Order Category"
        >
          {/* {mainType === 'crypto' ? (
            <>
              <ToggleButton value="Initiated" className="text-white">Initiated</ToggleButton> */}
          <ToggleButton value="Open" className="text-white">Open</ToggleButton>
          <ToggleButton value="Executed" className="text-white">Executed</ToggleButton>
          {/* </>
          ) : (
            <> */}
          {/* <ToggleButton value="Open" className="text-white">Open</ToggleButton>
          <ToggleButton value="Executed" className="text-white">Executed</ToggleButton> */}
          {/* </>
          )} */}
        </ToggleButtonGroup>
        {selectedCategory === 'Open' || selectedCategory === 'Initiated' ? (
          <>
            <Typography variant="h5" className="text-white" my="20px">
              {selectedCategory === 'Open' ? 'Open Orders' : 'Initiated Orders'}
            </Typography>
            <OpenOrder
              mainType={mainType}
              status={selectedCategory === 'Open' ? 'pending' : 'initiated'}
            />
          </>
        ) : selectedCategory === 'Executed' ? (
          <>
            <Typography variant="h5" className="text-white" my="20px">
              Executed Orders
            </Typography>
            <ExecutedOrder mainType={mainType} />
          </>
        ) : null}
      </Box>
      {/* <Box width='100%' >
        <Divider sx={{ border: '1px solid #FFFFFF33' }}></Divider>
        <Typography my='20px' className='text-white' textAlign='center'>Securities Products and Services are provided by Wolfpack Brokerage Services Inc. Member FINRA | SIPC.</Typography>
      </Box> */}
    </Container>
  );
}

export default Order;
